import React, { useEffect, useRef, useState } from "react";
import { SimpleLoader } from "senf-atomic-design-system";
import { auth } from "senf-shared";
import { useSearchParams } from "react-router-dom";
import { applyActionCode } from "firebase/auth";
import { useTranslation } from "react-i18next";
import { AuthPageWrapper } from "./components/AuthPageWrapper";

export const VerifyEmail = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string>();
  const [message, setMessage] = useState<string>();
  const verified = useRef(false);
  const [searchParams] = useSearchParams();
  const oobCode = searchParams.get("oobCode");
  const continueUrl = searchParams.get("continueUrl") || "/";
  const verifyEmail = async () => {
    applyActionCode(auth, oobCode || "")
      .then(() => {
        verified.current = true;
        setMessage("Email erfolgreich verifiziert");
      })
      .catch((error) => {
        if (verified.current) return;
        if (error.code === "auth/invalid-action-code") {
          setMessage("Email wurde bereits verifiziert");
          return;
        }
        if (error.code === "auth/expired-action-code") {
          setError("Der Link ist abgelaufen, bitte versuche es erneut");
          return;
        }
        setError("Ein Fehler ist aufgetreten, bitte versuche es erneut");
      })
      .finally(() => setLoading(false));
  };
  useEffect(() => {
    verifyEmail();
  }, []);

  if (loading) return <SimpleLoader />;
  return (
    <AuthPageWrapper
      message={{
        success: !error,
        error: !!error,
        text: error || message,
        action: {
          text: error ? "Erneut versuchen" : t("global:next"),
          onClick: () => {
            window.location.href = continueUrl;
          },
        },
      }}
    />
  );
};
